import ReactDOM from "react-dom/client";
import App from "./App";

window.onload = () => {
  // const maxFontSize = 500; // 1600px / 1440px * 100
  function setRootFontSize() {
    const isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    if (isMobile) {
      document.body.classList.add("mobile");
    }
    // 设计稿宽度（根据你的实际情况调整）
    const designWidth = isMobile ? 375 : 1440;
    // 最大 font-size（根据需求调整）
    const maxFontSize = 111.111; // 1600px / 1440px * 100
    const width = window.innerWidth;
    console.log("isMobile", isMobile, width);
    let fontSize = (width / designWidth) * 100;
    if (!isMobile) {
      fontSize = Math.min(fontSize, maxFontSize);
    }
    document.documentElement.style.fontSize = fontSize + "px";
  }
  // 初始化
  setRootFontSize();
  // 窗口大小变化时重新设置
  // window.addEventListener("resize", setRootFontSize);
  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
  );
  root.render(<App />);
};
